<div
    class="auth-screen-wrapper flex min-w-0 flex-auto flex-col items-center sm:flex-row sm:justify-center md:items-start md:justify-start add-padding"
>
    <div
        class="auth-left-side-image-box relative hidden h-full w-1/2 flex-auto items-center justify-center overflow-hidden p-16 dark:border-l md:flex lg:px-28 img-bg card-left-side-radius"
    >

        <div class="auth-left-side-image relative z-10 w-full max-w-2xl">
            <img src="grimmorLogo.svg" class="scale-[2]" alt="logo"/>
        </div>
    </div>
    <div class="auth-right-side-content w-full px-4 py-8 sm:bg-card sm:w-auto sm:p-12 sm:shadow md:flex md:h-full md:w-1/2 md:items-center justify-center md:p-16 md:shadow-none card-right-side-radius">
        <div class="auth-content-inner mx-auto w-full max-w-80 sm:mx-0 sm:w-80">
            <!-- Logo -->
            <div class="w-50">
            </div>

            <!-- Title -->
            <div
                class="xxl:mt-8 text-4xl font-extrabold leading-tight tracking-tight"
            >
              {{isPartner ? 'Partner Sign In':'Admin Sign In'}} 
<!--                <img src="grimmor-image.png" class="img-wrapper"/>-->
            </div>
            <!-- Sign in form -->
            <form #signInNgForm="ngForm" [formGroup]="signInForm" class="mt-8">
                <!-- Email field -->
                <mat-form-field class="w-full" floatLabel="always">
                    <mat-label>{{LABELS.EMAIL_ADDRESS}}</mat-label>
                    <input [formControlName]="'email'" id="email" matInput [placeholder]="LABELS.ENTER_EMAIL_ADDRESS"/>
                    @if (signInForm.get('email').hasError('required')) {
                        <mat-error>{{LABELS.EMAIL_REQUIRED}}</mat-error>
                    }
                    @if (signInForm.get('email').hasError('email')) {
                        <mat-error>
                            {{LABELS.VALID_EMAIL}}
                        </mat-error>
                    }
                    @if (signInForm.get('email').hasError('pattern')) {
                        <mat-error>
                            {{LABELS.VALID_EMAIL}}
                        </mat-error>
                    }
                </mat-form-field>
                <!-- Password field -->
                <mat-form-field class="w-full" floatLabel="always">
                    <mat-label>{{LABELS.PASSWORD}}</mat-label>
                    <input
                        #passwordField
                        [formControlName]="'password'"
                        id="password"
                        matInput
                        type="password"
                        [placeholder]="LABELS.ENTER_PASSWORD"
                    />
                    <button
                        (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        "
                        mat-icon-button
                        matSuffix
                        type="button"
                    >
                        @if (passwordField.type === 'password') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye'"
                            ></mat-icon>
                        }
                        @if (passwordField.type === 'text') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye-slash'"
                            ></mat-icon>
                        }
                    </button>
                    <mat-error> {{LABELS.PASSWORD_REQUIRED}}</mat-error>
                </mat-form-field>

                <!-- Actions -->
                <div
                    class="mt-1.5 inline-flex w-full items-center justify-between"
                >
                    <mat-checkbox
                        [formControlName]="'rememberMe'"
                        class="-ml-2 "
                    >
                        {{LABELS.REMEMBER_ME}}
                    </mat-checkbox>
                    <div></div>
                    <a
                        [routerLink]=" _router.url.indexOf('/partner/') !== -1  ? ['/partner/forgot-password'] : ['forgot-password']"
                        class="text-md font-medium theme-color hover:underline"
                    >{{LABELS.FORGOT_PASSWORD}}?
                    </a>
                </div>

                <!-- Submit button -->
                <button
                    (click)="signIn()"
                    [disabled]="signInForm.disabled"
                    class="fuse-mat-button-large mt-6 w-full btn-theme-color"
                    mat-flat-button
                >
                    @if (!signInForm.disabled) {
                        <span> {{LABELS.SING_IN}} </span>
                    }

                    @if (signInForm.disabled) {
                        <mat-progress-spinner
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    }
                </button>
            </form>
        </div>
    </div>
</div>
